import { useState, useEffect } from 'react';
import { createClient } from 'contentful';

/**
 * useContentfulClient hook
 * @description Creates a Contentful client for use within react components
 * @param {*} contentfulCredentials
 * @returns Contentful.ContentfulClientApi
 */

const useContentfulClient = contentfulCredentials => {
  const [client, setContentfulClient] = useState(null);

  useEffect(() => {
    setContentfulClient(createClient(contentfulCredentials));
  }, []);

  return client;
};

export default useContentfulClient;
